import RichText from "@/components/RichText"
import { cleanString, cn } from "@/lib/utils"
import { createDataAttribute, PortableTextBlock } from "next-sanity"

interface ProjectTextBlockProps {
	text: PortableTextBlock[]
	width?: string
	size?: string
	align?: string
	documentId: string
	_key: string
}

export default function ProjectTextBlock({text, width, size = "medium", align, documentId, _key}:ProjectTextBlockProps) {
	return (
			<div
				className={cn(`col-span-full`, {
					"md:col-span-6" : cleanString(width) !== "full",
					"md:col-start-7" : (cleanString(width) !== "full" && cleanString(align) === "right")
				})}
				key={_key}
				data-sanity={createDataAttribute({
					id: documentId,
					type: 'project',
					path: `contentBlocks[_key=="${_key}"]`,
				}).toString()}
			>
				<div className="site-grid">
					<div className={cn(`col-span-full`, {
						"md:col-span-full" : cleanString(width) === "full",
						"md:col-span-6" : cleanString(width) !== "full",
						"text-6xl leading-105 -tracking-10 mobile:text-balance" : cleanString(size) === "large",
						"text-2xl leading-115 -tracking-10" : cleanString(size) === "medium" || !size
					})}>
						<div className="font-400 [&_strong]:font-500 prose">
							<RichText content={text} />
						</div>
					</div>
				</div>
			</div>
	)
}